import cardValidator from 'card-validator';
import { addMethod, StringSchema } from 'yup';

import { config } from 'data';

import { createError } from '../helpers';

addMethod(StringSchema, 'cardNumber', function validate() {
  return this.trim()
    .transform((value) => {
      value = value?.replace(/\D/g, '');

      return value || null;
    })
    .min(config.CARD_NUMBER_MIN_LENGTH)
    .max(config.CARD_NUMBER_MAX_LENGTH)
    .test((value, context) => {
      if (!value) {
        return true;
      }

      const verification = cardValidator.number(value);

      if (verification.isValid) {
        return true;
      }

      return createError(context, 'cardNumber');
    });
});
